export enum RespirationStatus
{
    Normal = 1,
    Abnormal = 2
}